import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ClearIcon from '@mui/icons-material/Clear';
import { Button, Container, Modal, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { saveOrganization } from '../../redux/reducers/organizationReducer';

function CreateOrganizationModal({ handleClose }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [details, setDetails] = useState({
    name: '',
    description: '',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    const newDetails = { ...details };
    newDetails[name] = value;
    setDetails(newDetails);
  };

  const handleSave = () => {
    dispatch(saveOrganization(details));
    handleClose();
  };

  return (
    <Modal open>
      <Container variant="modal" disableGutters>
        <Container variant="formContainer" disableGutters>
          <Stack spacing={2}>
            <Typography id='create-organization-title' variant="h6">{t('organization.createTitle')}</Typography>
            <TextField
              id="name"
              name="name"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              label={t('organization.name')}
              value={details.name}
              onChange={(event) => handleChange(event)}
              required
            />
            <TextField
              id="description"
              name="description"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              label={t('organization.description')}
              multiline
              rows={6}
              value={details.description}
              onChange={(event) => handleChange(event)}
            />
          </Stack>
        </Container>
        <Container variant="buttonRow" disableGutters>
          <Stack direction="row" justifyContent="flex-end">
            <Button variant="text" startIcon={<ClearIcon />} onClick={() => handleClose()}>
              {t('cancel')}
            </Button>
            <Button
              id='create-organization'
              variant="contained"
              disabled={!details.name}
              startIcon={<AddRoundedIcon />}
              onClick={() => handleSave()}
            >
              {t('organization.createTitle')}
            </Button>
          </Stack>
        </Container>
      </Container>
    </Modal>
  );
}

export default CreateOrganizationModal;
